module.exports = __webpack_public_path__ + "media/customizations/avimor/logo-new-905002afbffd58f31387a8479cf87045.png";